import PropTypes from 'prop-types';

export default PropTypes.shape({
  type: PropTypes.oneOf(['hector', 'static']).isRequired,
  url: PropTypes.string.isRequired,
  queryParams: PropTypes.object.isRequired, // { [string]: string }
  width: PropTypes.number,
  height: PropTypes.number,
  credit: PropTypes.string,
  creditUrl: PropTypes.string,
});
